export type TransactionType = 'deposit' | 'withdrawal' | 'transfer' | 'payment';

export interface Wallet {
  id: string;
  user_id: string;
  balance: number;
  currency: string;
  created_at: string;
  updated_at: string;
}

export interface WalletTransaction {
  id: string;
  user_id: string;
  type: TransactionType;
  amount: number;
  status: string;
  method: string | null;
  reference: string | null;
  description: string | null;
  balance_after: number | null;
  direction: string | null;
  counterparty_name: string | null;
  created_at: string;
}

export const DEPOSIT_METHODS = ['Mobile Money', 'Carte bancaire', 'PayDunya', 'Virement bancaire'];
export const WITHDRAWAL_METHODS = ['Mobile Money', 'Virement bancaire'];

export function formatMoney(amount: number, currency = 'XOF'): string {
  const num = Number(amount) || 0;
  const formatted = num.toLocaleString('fr-FR', { maximumFractionDigits: 0 });
  return `${formatted} ${currency}`;
}

export function transactionLabel(type: TransactionType): string {
  switch (type) {
    case 'deposit':
      return 'Dépôt';
    case 'withdrawal':
      return 'Retrait';
    case 'transfer':
      return 'Transfert';
    case 'payment':
      return 'Paiement';
    default:
      return type;
  }
}

export function transactionIcon(type: TransactionType): string {
  switch (type) {
    case 'deposit':
      return 'ri-arrow-down-circle-line';
    case 'withdrawal':
      return 'ri-arrow-up-circle-line';
    case 'transfer':
      return 'ri-exchange-line';
    case 'payment':
      return 'ri-shopping-bag-3-line';
    default:
      return 'ri-exchange-line';
  }
}

export function formatDate(iso: string): string {
  const d = new Date(iso);
  return d.toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

export function formatDateTime(iso: string): string {
  const d = new Date(iso);
  const date = d.toLocaleDateString('fr-FR', { day: '2-digit', month: 'short', year: 'numeric' });
  const time = d.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
  return `${date} · ${time}`;
}